import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from './auth.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CommissionsService {
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Inject(AuthService) private authService: AuthService,
  ) {}

  create(data) {
    const headers = new HttpHeaders({
      Authorization: this.authService.getToken().token,
      accept: 'application/json',
    });
    return this.http.post(
      `${environment.API_URI}/invoice`,
      { ...data },
      { headers },
    );
  }

  getById(id: number) {
    const headers = new HttpHeaders({
      Authorization: this.authService.getToken().token,
      accept: 'application/json',
    });
    return this.http.get(`${environment.API_URI}/invoice/${id}`, {
      headers,
    });
  }
}
